import React, { createContext,useEffect, useState} from 'react';

// === STYLE / MATERIAL UI ===
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import './index.css';

// API
import {onMonitorModules, onMonitorModulesUpdate, removeListener} from 'api/prokey/prokey.websocket';

//-----------------------------------------------------------------
export function ModulePanel() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const [ modules , setModules ] = useState( {} );

  //#endregion

  //#region [STYLES]


  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    //-----------------------------------------------------------------
    function handleModules( data ) {
      //-----------------------------------------------------------------
      setModules( data );
    };

    onMonitorModules( handleModules );

    return () => {
      removeListener( 'WORKFLOW-MONITOR-MODULES' , handleModules );
    };
  }, []);

  useEffect(() => {

    //-----------------------------------------------------------------
    function handleModulesUpdate( data ) {
      //-----------------------------------------------------------------
      const temp = { ...modules };
      data.create.forEach( module => {
        temp[module.name] = module;
      });

      data.update.forEach( module => {
        temp[module.name] = module;
      });

      data.remove.forEach( module => {
        delete temp[module.name];
      });
      
      setModules( temp );
    };

    onMonitorModulesUpdate( handleModulesUpdate );

    return () => {
      removeListener( 'WORKFLOW-MONITOR-MODULES-UPDATE' , handleModulesUpdate );
    };
  }, [modules]);

  //#endregion

  //#region [METHOD] 

  //-----------------------------------------------------------------
  function strPrep(str) {
    //-----------------------------------------------------------------
    str = str.toString();
    str = str.replaceAll('_', ' ');
    str = str.toLowerCase().split(' ');
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

  //-----------------------------------------------------------------
  function getNameSortVal(name) {
    //-----------------------------------------------------------------
    let ret = 0;
    if (name.toLowerCase().includes('writepdf_pkweb')) ret = 0;
    else if (name.toLowerCase().includes('aida')) ret = 1;
    else if (name.toLowerCase().includes('prokey')) {
      if (name.toLowerCase().includes('silent')) ret = 2.1;
      else if (name.toLowerCase().includes('auto')) ret = 2.2;
      else if (name.toLowerCase().includes('class')) ret = 2.3;
      else if (name.toLowerCase().includes('version')) ret = 2.4;
      else if (name.toLowerCase().includes('extract')) ret = 2.5;
      else ret = 2.6;
    } else if (name.toLowerCase().includes('statistics')) ret = 5;
    else if (name.toLowerCase().includes('writepdf')) ret = 6;
    else if (name.toLowerCase().includes('export')) ret = 7;
    return ret;
  }

  //#endregion

  //#region []

  //-----------------------------------------------------------------
  function displayModuleRowEntries(data, key) {
    //-----------------------------------------------------------------
    let result = [];
    for (const i in data) {
      const props = {
        sx: {
          minWidth: '6rem',
        },
        align: 'right',
      }

      const value_orig = data[i][key];
      const is_header = isNaN(value_orig);
      const value = is_header ? strPrep(value_orig) : value_orig;

      if( is_header ) props.sx.color = theme.palette.primary.main;

      if( !is_header && value > 0 ) {
        props.sx.color = theme.palette.success.main;
      }

      result.push(
        <TableCell { ...props } key={i + 1} >
          { value }
        </TableCell>
      );
    }
    return result;
  };

  //-----------------------------------------------------------------
  function displayModuleData() {
    //-----------------------------------------------------------------
    const modules_arr = Object.values( modules );
    if (modules_arr.length === 0) {
      return <div></div>;
    } else {
      let result = [];

      const data = modules_arr.sort((a, b) => {
        const aval = getNameSortVal(a.name);
        const bval = getNameSortVal(b.name);
        return aval - bval;
      });

      result.push(
        <div
          key={0}
          sx={{
            overflowX: 'auto',
            width: '100%',
          }}
        >
          <Table
            key={0}
            size='small'
            sx={{
              tableLayout: 'auto',
              width: '100%',
            }}
          >
            <TableHead key={0}>
              <TableRow key={0}>
                <TableCell
                  key={0}
                  sx={{
                    minWidth: '6rem',
                  }}
                >
                  Module
                </TableCell>
                {displayModuleRowEntries(data, 'name')}
              </TableRow>
            </TableHead>
            <TableBody key={1}>
              <TableRow key={1}>
                <TableCell key={0}>Working</TableCell>
                {displayModuleRowEntries(data, 'items')}
              </TableRow>
              <TableRow key={2}>
                <TableCell key={0}>Pending</TableCell>
                {displayModuleRowEntries(data, 'pending')}
              </TableRow>
              <TableRow key={3}>
                <TableCell key={0}>Errored</TableCell>
                {displayModuleRowEntries(data, 'errors')}
              </TableRow>
              <TableRow key={4}>
                <TableCell key={0}>Suspend</TableCell>
                {displayModuleRowEntries(data, 'suspended')}
              </TableRow>
            </TableBody>
          </Table>
        </div>
      );
      return result;
    }
  };

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return displayModuleData();
  }

  //#endregion

  return display();
}
